import { HttpClient } from "@angular/common/http";
import { Endpoints } from "src/app/shared/config/endpoints";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/app.state";
import { BehaviorSubject, Observable } from "rxjs";
import * as io from "socket.io-client";
import { Socket } from "socket.io-client";
import { ToastrService } from "ngx-toastr";
import { catchError, tap } from "rxjs/operators";
@Injectable({
  providedIn: "root",
})
export class TiktokService {
  private orgId!: number;
  private userId!: number;
  private userName!: string;
  private userRole!: string;
  private baseUri = this.endpoints.tiktokServiceUrl;
  private tiktokSocket!: Socket;
  postToView = new BehaviorSubject<any>({});
  public newComment = new BehaviorSubject<any>(null);
  public newMention = new BehaviorSubject<any>(null);
  public newPost = new BehaviorSubject<any>(null);
   private normalizeEventName(event: string): string {
      switch (event.toLowerCase()) {
        case 'comments':
          return 'COMMENT';
        case 'mentions':
          return 'BRAND_MENTION';
        case 'posts':
          return 'VIDEO';
        case 'dm':
          return 'DIRECT_MESSAGE';
        default:
          return event.toUpperCase();
      }
    }

  connectedAccount = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    private store: Store<AppState>,
    private toastr: ToastrService
  ) {
    this.store.select("userInfo").subscribe((info) => {
      if (info.organization && info.user) {
        this.orgId = info.organization.id;
        this.userId = info.user.id;
        this.userName = `${info.user.firstName || ''} ${info.user.lastName || ''}`.trim();
      }
      this.userRole = info && info.roleName === 'Super Admin'
        ? 'ADMIN'
        : info && info.supervisor
          ? 'SUPERVISOR'
          : 'AGENT';
    });
  }

  startLogin(): void {
    window.location.href = `${this.baseUri}/oauth?orgId=${this.orgId}&userId=${this.userId}`;
  }

  finishLogin(code: string, state: string): Observable<any> {
    return this.http.get(
      `${this.baseUri}/auth/exchange?auth_code=${code}&state=${state}&orgId=${this.orgId}&userId=${this.userId}`
    );
  }

  private initializeSocket(): void {
    if (this.tiktokSocket) {
      this.tiktokSocket.disconnect();
    }
  this.tiktokSocket = io.connect(this.baseUri, {
    transports: ['websocket', 'polling'],
        upgrade: true,
        withCredentials: true,
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 5,
        timeout: 20000,
        forceNew: false,
        path: "/socket.io",
        query: {
          orgId: this.orgId.toString(),
        },
      }
    );
    this.tiktokSocket.on("connect", () => {
      this.tiktokSocket.emit("join_org", this.orgId);
    });
    this.tiktokSocket.on("connect_error", (error: any) => {
      console.error("Socket connection error:", error);
      console.error("Error message:", error.message);
      console.error("Error type:", error.type);
      if (this.tiktokSocket.io && this.tiktokSocket.io.engine) {
        console.error(
          "Failed transport:",
          this.tiktokSocket.io.engine.transport.name
        );
      }
    });

    this.tiktokSocket.on("connect_timeout", (timeout: any) => {
      console.error("Socket connection timeout:", timeout);
    });

    this.tiktokSocket.on("reconnect_attempt", (attemptNumber: number) => {
      console.log(`Reconnection attempt #${attemptNumber}`);
    });

    this.tiktokSocket.on("reconnect_failed", () => {
      console.error("Reconnection failed after all attempts");
    });

    this.tiktokSocket.on("reconnect", (attemptNumber: number) => {
      console.log(`Reconnected successfully after ${attemptNumber} attempts`);
      this.tiktokSocket.emit("join_org", this.orgId);
      this.tiktokSocket.on("joined_org", (data: any) => {
      });
    });

    this.tiktokSocket.on("disconnect", (reason: string) => {

      if (reason === "io server disconnect") {

        this.tiktokSocket.connect();
      }
    });
    this.tiktokSocket.on("error", (error: any) => {
      console.error("Socket error:", error);
    });

this.tiktokSocket.on("post_status_update", (data: any) => {

  this.newPost.next(data);
  if (data) {
    this.toastr.success(
      `You posted a TikTok video.`,
      "TikTok Post"
    );
  }
});

this.tiktokSocket.on("new_comment", (data: any) => {

  this.newComment.next(data);
  if (data) {
    this.toastr.success(
      `You've got a new comment on your TikTok video.`,
      "TikTok Comment"
    );
  }
});

this.tiktokSocket.on("new_mention", (data: any) => {

  this.newMention.next(data);
  if (data) {
    this.toastr.success("Someone just mentioned you in a TikTok post!", "TikTok Mention");
  }
});
  }

  disconnectSocket(): void {
    if (this.tiktokSocket) {
      this.tiktokSocket.disconnect();
      this.tiktokSocket = null as any;
    }
  }
  getStatus(): Observable<any> {
    return this.http.get(`${this.baseUri}/auth/status?orgId=${this.orgId}`);
  }

  replyToComment(
    videoId: string,
    commentId: string,
    text: string,
    isMention: boolean = false
  ): Observable<any> {
    return this.http.post(
      `${this.baseUri}/tiktok/comment/reply/${this.orgId}`,
      {
        video_id: videoId,
        comment_id: commentId,
        text: text,
        is_mention: isMention,
        reply_by_id: this.userId,
        reply_by_name: this.userName,
        reply_by_role: this.userRole,
      }
    );
  }

  deleteReplyResponse(videoId: string, commentId: string, isMention: boolean = false): Observable<any> {
    return this.http.post(
      `${this.baseUri}/tiktok/comment/reply/${this.orgId}/unsend`,
      {
        video_id: videoId,
        comment_id: commentId,
        is_mention: isMention,
        deleted_by: this.userName,
        deleted_by_role: this.userRole,
        deleted_by_id: this.userId,
      }
    );
  }
subscribeToEvents(eventTypes: string[]): Observable<any> {
  const body = { eventTypes };
  return this.http
    .post(`${this.baseUri}/webhook/subscribe-events?orgId=${this.orgId}`, body)
    .pipe(
      tap(() => {
        this.initializeSocket();
      }),
      catchError((error) => {
        console.error("Error subscribing to events:", error);
        throw error;
      })
    );
}


  deleteUnselectedWebhook(selectedEvents: string[]): Observable<any> {
    return this.http.post(
      `${this.baseUri}/webhook/delete-unselected-webhook?orgId=${this.orgId}`,
      {selectedEvents}
    );
  }

  deleteSubbedWebhook(payload: { events: string[] }): Observable<any> {
    if (!payload || !payload.events || !payload.events.length) {
      throw new Error("No events provided to delete");
    }

    const normalizedEvents = payload.events.map(this.normalizeEventName);

    return this.http.post(
      `${this.baseUri}/webhook/delete-subbed-events?orgId=${this.orgId}`,
      { events: normalizedEvents }
    );
  }

  disconnectWebhook(eventType?: string): Observable<any> {
    const body: any = {};
    if (eventType) body.event_type = eventType;

    return this.http.post(
      `${this.baseUri}/webhook/disconnect?orgId=${this.orgId}`,
      body
    );
  }

  disconnectAccount(): Observable<any> {
    return this.http.post(`${this.baseUri}/auth/disconnect`, {
      orgId: this.orgId,
    });
  }

  fetchFeeds(): Observable<any> {
    return this.http.get(`${this.baseUri}/tiktok/feeds/${this.orgId}`);
  }

  fetchVideoComments(): Observable<any> {
    return this.http.get(`${this.baseUri}/tiktok/comments/all/${this.orgId}`);
  }

  fetchMentionsInComments(): Observable<any> {
    return this.http.get(
      `${this.baseUri}/tiktok/mentions/comments/${this.orgId}`
    );
  }

  fetchMentionsInVideos(): Observable<any> {
    return this.http.get(`${this.baseUri}/tiktok/mentions/posts/${this.orgId}`);
  }

  fetchTiktokPosts(): Observable<any> {
    return this.http.get(`${this.baseUri}/tiktok//tiktok/posts/completed/${this.orgId}`)
  }

  registerWebhook(accessToken: string, advertiserId: string): Observable<any> {
    return this.http.post(`${this.baseUri}/webhook/register`, {
      accessToken,
      advertiserId,
    });
  }

  getWebhookEvents(): Observable<any> {
    return this.http.get(
      `${this.baseUri}/webhook/events?orgId=${this.orgId}`
    );
  }

    fetchAccount(): Observable<any>{
    return this.http.get(
        `${this.baseUri}/tiktok/account/${this.orgId}`
    )
  }

  getVideoDetails(videoId: string): Observable<any> {
    return this.http.get(`${this.baseUri}/tiktok/video/${videoId}`);
  }
}
